module.exports = __webpack_public_path__ + "img/Emily Wigoder.8819425e.jpg";